/**
 * AuthLayout — full-screen sin Navbar/Footer para /auth/*.
 *
 * Las páginas auth ya pintan su propio card centrado, pero el layout debe
 * proveer:
 *   - SkipLink (WCAG 2.4.1 Bypass Blocks) — primer foco al cargar.
 *   - <main id="main" tabIndex={-1}> como landmark único de la página
 *     (WCAG 1.3.1 Info & Relationships) y target del SkipLink.
 *
 * F8a auditó esto como CRITICAL: sin estos elementos, ningún SR puede
 * orientar al usuario en /auth/* y el SkipLink global no tiene a dónde
 * saltar (degradaría la experiencia de teclado).
 */
import { Outlet } from 'react-router-dom';
import { SkipLink } from '../../components/layout/SkipLink';
import { ScrollToTop } from '../../components/layout/ScrollToTop';

export function AuthLayout() {
  return (
    <>
      {/* Restore scroll al cambiar de ruta dentro de /auth/*. */}
      <ScrollToTop />
      <SkipLink />
      <main id="main" tabIndex={-1} className="min-h-screen focus:outline-none">
        <Outlet />
      </main>
    </>
  );
}
